import { render } from "./PageNotFound.vue?vue&type=template&id=0157b027"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script